<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="E-mail de notification">
        <b-form @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="E-mail" label-for="h-email" label-cols-md="4">
                <b-form-input id="h-email" type="email" placeholder="E-mail" v-model="setting.email" />
              </b-form-group>
            </b-col>
            <b-col offset-md="10">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
                Enregistrer
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
      <hr>

      <b-card title="Personne décisionnaire">
        <b-form @submit.prevent="handleSubmitUser">
          <b-row>
            <b-col cols="6">
              <h5>Siège</h5>
              <b-form-group>
                <v-select v-model="user_s" label="fullName" :options="users" placeholder="Sélectionner un utilisateur"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <h5>Péage</h5>
              <b-form-group>
                <v-select v-model="user_p" label="fullName" :options="users" placeholder="Sélectionner un utilisateur"/>
              </b-form-group>
            </b-col>
            <b-col offset-md="10">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
                Enregistrer
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>

      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form @submit.prevent="handleSubmit">
              <div class="card-header p-0 mb-3 d-flex flex-column align-items-start">
                <b-card-title class="mb-2">Année de définition des objectifs</b-card-title>
                <b-dropdown
                    v-model="setting.yearObjective"
                    :text="setting.yearObjective ? `${setting.yearObjective.year}` : 'Sélectionnez une année'"
                    size="md"
                    class="budget-dropdown w-25"
                    variant="outline-primary"
                    v-b-popover.hover.top="'L\'année des objectifs doit correspondre à l\'année pour laquelle on veut définir objectifs !'"
                    title="Information"
                >
                  <b-dropdown-item v-for="year in years" :key="year.year" @click="handleYearObjectiveSelection(year)">
                    {{ year.year }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <div class="card-header p-0 mb-2 d-flex justify-content-start align-items-center">
                <div>
                  <b-card-title class="text-primary">Délai avant rappel quotidien des objectifs</b-card-title>
                </div>
              </div>


              <b-row>
                <b-col md="6" cols="12">
                  <div>
                    <h5>Date de début</h5>

                    <flat-pickr
                        v-model="setting.objectiveStartDate"
                        class="form-control"
                        :config="{
                      dateFormat: 'd-m-Y',
                      altInput: true,
                      altFormat: 'd-m-Y',
                      locale: French
                    }"/>
                  </div>
                </b-col>
                <b-col md="6" cols="12">
                  <b-form-group label-for="objective-delay">
                    <h5>Nombre de Jour</h5>
                    <b-form-spinbutton v-model="setting.objectiveRelanceDelay" min="1" max="20" />
                  </b-form-group>
                </b-col>
                <b-col class="d-flex justify-content-end mt-2">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary">
                    Enregistrer
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>

        <b-col cols="12">
          <b-card>
            <b-form @submit.prevent="handleSubmit">
              <div class="card-header p-0 mb-2 d-flex flex-column align-items-start">
                <b-card-title class="mb-2">Année à évaluer</b-card-title>
                  <b-dropdown
                    v-model="setting.yearEvaluation"
                    :text="setting.yearEvaluation ? `${setting.yearEvaluation.year}` : 'Sélectionnez une année'"
                    size="md"
                    class="budget-dropdown w-25"
                    variant="outline-primary"
                    v-b-popover.hover.top="'L\'année des évaluations doit correspondre à l\'année dont on veut évaluer les objectifs !'"
                    title="Information"
                  >
                  <b-dropdown-item v-for="year in years" :key="year.year" @click="handleYearEvaluationSelection(year)">
                    {{ year.year }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <b-row>
                <b-col md="6" cols="12">
                  <div class="card-header p-0 mb-2 d-flex justify-content-start align-items-center">
                    <div>
                      <b-card-title class="text-primary">Délai avant rappel quotidien des auto évaluations</b-card-title>
                    </div>
                  </div>
                </b-col>
                <b-col md="6" cols="12">
                  <div class="card-header p-0 mb-2 d-flex justify-content-start align-items-center">
                    <div>
                      <b-card-title class="text-primary">Date début des évaluations</b-card-title>
                    </div>
                  </div>
                </b-col>

                <b-col md="3" cols="12">
                  <div>
                    <h5>Date de début</h5>
                    <flat-pickr
                        v-model="setting.autoEvaluationStartDate"
                        class="form-control"
                        :config="{
                      dateFormat: 'd-m-Y',
                      altInput: true,
                      altFormat: 'd-m-Y',
                      locale: French
                    }"/>


                  </div>
                </b-col>
                <b-col md="3" cols="12">
                  <b-form-group label-for="evaluation-delay">
                    <h5>Nombre de Jour</h5>
                    <b-form-spinbutton v-model="setting.autoEvaluationRelanceDelay" min="1" max="20" />
                  </b-form-group>
                </b-col>



                <b-col md="6" cols="12">
                  <div>
                    <h5>Date de début</h5>
                    <flat-pickr
                        v-model="setting.evaluationStartDate"
                        class="form-control"
                        :config="{
    dateFormat: 'd-m-Y',
    altInput: true,
    altFormat: 'd-m-Y',
    locale: French
  }"
                    />
                  </div>
                </b-col>


                <b-col class="d-flex justify-content-end mt-2">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary">
                    Enregistrer
                  </b-button>
                </b-col>
              </b-row>

            </b-form>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card>
            <div class="card-header p-0 mb-2 d-flex justify-content-between align-items-center">
              <b-card-title class="text-primary">Intervalle des collaborateurs</b-card-title>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="$bvModal.show('add-config-modal')"
              >
                Ajouter configuration
              </b-button>
            </div>

            <!-- Liste des configurations -->
            <b-table
                :items="evaluationIntervalConfigs"
                :fields="configFields"
                responsive
                class="mb-0"
            >
              <template #cell(actions)="row">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <more-vertical-icon size="16" class="text-body align-middle mr-25" />
                  </template>
                  <b-dropdown-item
                    @click="editConfig(row.item)"
                  >
                    <edit-2-icon class="mr-50" />
                    <span>Modifier</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                   @click="deleteConfig(row.item.id)"
                  >
                    <trash-icon class="mr-50" />
                    <span>Supprimer</span>
                  </b-dropdown-item>

                </b-dropdown>
              </template>
            </b-table>
          </b-card>

        </b-col>
      </b-row>

      <!-- Modal for Objective Custom Year -->
      <b-modal
          id="objective-year-modal"
          title="Saisir une année"
          ok-title="Confirmer"
          cancel-title="Annuler"
          centered
          @ok="handleObjectiveYearSubmit"
          @hidden="resetObjectiveYearModal"
      >
        <b-form-group label="Année" label-for="custom-objective-year">
          <b-form-input
              id="custom-objective-year"
              type="number"
              v-model="customObjectiveYear"
              placeholder="Entrez une année (ex. 2025)"
              min="2023"
              max="2100"
          />
        </b-form-group>
      </b-modal>

      <!-- Modal for Evaluation Custom Year -->
      <b-modal
          id="evaluation-year-modal"
          title="Saisir une année personnalisée"
          ok-title="Confirmer"
          cancel-title="Annuler"
          centered
          @ok="handleEvaluationYearSubmit"
          @hidden="resetEvaluationYearModal"
      >
        <b-form-group label="Année" label-for="custom-evaluation-year">
          <b-form-input
              id="custom-evaluation-year"
              type="number"
              v-model="customEvaluationYear"
              placeholder="Entrez une année (ex. 2025)"
              min="2023"
              max="2100"
          />
        </b-form-group>
      </b-modal>

      <!-- Modale pour ajouter/modifier une configuration -->
      <b-modal
          id="add-config-modal"
          :title="editingConfig ? 'Modifier configuration' : 'Ajouter configuration'"
          ok-title="Enregistrer"
          cancel-title="Annuler"
          centered
          @ok="handleConfigSubmit"
          @hidden="resetConfigModal"
      >
        <b-form-group label="Nombre minimum de collaborateurs" label-for="min-collaborators">
          <b-form-input
              id="min-collaborators"
              type="number"
              v-model.number="newConfig.minCollaborators"
              placeholder="Ex. 1"
              min="0"
          />
        </b-form-group>
        <b-form-group label="Nombre maximum de collaborateurs" label-for="max-collaborators">
          <b-form-input
              id="max-collaborators"
              type="number"
              v-model.number="newConfig.maxCollaborators"
              placeholder="Ex. 5"
              min="1"
          />
        </b-form-group>
        <b-form-group label="Nombre de jours" label-for="interval-days">
          <b-form-input
              id="interval-days"
              type="number"
              v-model.number="newConfig.intervalDays"
              placeholder="Ex. 5"
              min="1"
          />
        </b-form-group>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BModal,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {getSetting, saveSetting, updateSetting} from '@/services/SettingService';
import {getAllDisabledUsers} from '@/services/UserService';
import vSelect from 'vue-select';
import {Edit2Icon, MoreVerticalIcon, TrashIcon,} from "vue-feather-icons";
import {
  getAllDecisionMakingUser,
  saveAllDecisionMakingUser,
  updateAllDecisionMakingUser
} from '@/services/DecisionMakingUserService';
import flatPickr from 'vue-flatpickr-component';
import {addYears, allYears} from '@/services/YearsService';
import {addConfig, deleteConfig, getAllConfigs, updateConfig} from '@/services/EvaluationIntervalConfigsService';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {French} from "flatpickr/dist/l10n/fr";

export default {
  computed: {
    French() {
      return French
    }
  },
  components: {
    BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BDropdown, BDropdownItem, BModal,
    vSelect,
    flatPickr,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      setting: {
        id: null,
        email: '',
        yearObjective: null,
        objectiveStartDate: null,
        objectiveRelanceDelay: 1,
        yearEvaluation: null,
        evaluationStartDate: null,
        evaluationRelanceDelay: 0,
        autoEvaluationStartDate: 0,
        autoEvaluationRelanceDelay: null,
      },
      decisionMakingUser: [
        { id: null, site: 'SIRAT', user: { id: null } },
        { id: null, site: 'PEAGE', user: { id: null } },
      ],
      user_s: {},
      user_p: {},
      users: [],
      selectedToll:{},
      objectiveDelay: null,
      evaluationDelay: null,
      years: [],
      customObjectiveYear: null,
      customEvaluationYear: null,
      evaluationIntervalConfigs: [], // Liste des configurations
      newConfig: {
        id: null,
        minCollaborators: null,
        maxCollaborators: null,
        intervalDays: null,
      },
      editingConfig: false, // Pour différencier ajout/modification
      configFields: [
        { key: 'minCollaborators', label: 'Min Collaborateurs', sortable: true },
        { key: 'maxCollaborators', label: 'Max Collaborateurs', sortable: true },
        { key: 'intervalDays', label: 'Jours', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    showToast (message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },
    async handleSubmitUser() {
      try {

        if (!this.decisionMakingUser[0]) {
          this.decisionMakingUser[0] = { site: 'SIRAT', user: {} };
        }
        if (!this.decisionMakingUser[1]) {
          this.decisionMakingUser[1] = { site: 'PEAGE', user: {} };
        }

        // Affectez les utilisateurs sélectionnés
        this.decisionMakingUser[0].user = this.user_s || {};
        this.decisionMakingUser[1].user = this.user_p || {};

        const response = this.decisionMakingUser.id
            ? await updateAllDecisionMakingUser(this.decisionMakingUser)
            : await saveAllDecisionMakingUser(this.decisionMakingUser);

        this.decisionMakingUser = response

        this.showToast('Personne décisionnaire mise à jour avec succès', 'success', 'CheckIcon')
      } catch (error) {
        console.error('Error updating decision-making users:', error);
        this.showToast('Échec de la mise à jour des personnes décisionnaires', 'danger', 'XIcon')
      }
    },

    async handleSubmit() {
      try {
        this.setting = this.setting.id
            ? await updateSetting(this.setting.id, this.setting)
            : await saveSetting(this.setting);
        this.showToast('Paramètres mis à jour avec succès', 'success', 'CheckIcon')
      } catch (error) {
        console.error('Error saving setting:', error);
        this.showToast('Échec de la mise à jour de l’e-mail', 'danger', 'XIcon')
      }

    },

    // async handleSubmitObjectiveDelay() {
    //   try {
    //     const response = await updateObjectiveDelay(this.objectiveDelay);

    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Délai avant rappel des objectifs mis à jour avec succès',
    //         icon: 'CheckIcon',
    //         variant: 'success',
    //       },
    //     });

    //     // Optionnel: mettre à jour localement si besoin
    //     this.objectiveDelay = response.objectiveRelanceDelay;
    //   } catch (error) {
    //     console.error('Erreur lors de la mise à jour du délai des objectifs:', error);
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Échec de la mise à jour du délai des objectifs',
    //         icon: 'XIcon',
    //         variant: 'error',
    //       },
    //     });
    //   }
    // },

    // async handleSubmitEvaluationDelay() {
    //   try {
    //     const response = await updateEvaluationDelay(this.evaluationDelay);
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Délai avant rappel des évaluations mis à jour avec succès',
    //         icon: 'CheckIcon',
    //         variant: 'success',
    //       },
    //     });

    //     // Optionnel: mettre à jour localement si besoin
    //     this.evaluationDelay = response.evaluationRelanceDelay;
    //   } catch (error) {
    //     console.error('Erreur lors de la mise à jour du délai des évaluations:', error);
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'Échec de la mise à jour du délai des évaluations',
    //         icon: 'XIcon',
    //         variant: 'error',
    //       },
    //     });
    //   }
    // },

    async getAllYears() {
      try {
        const response = await allYears();
        const hasOthers = response.some(year => year.year === 'Autres');
        if (!hasOthers) {
          response.push({ year: 'Autres' });
        }
        this.years = response;
      } catch (error) {
        console.error('Error fetching years:', error);
        this.years = [];
      }
    },
    handleYearObjectiveSelection(year) {
      if (year.year === 'Autres') {
        this.$bvModal.show('objective-year-modal');
      } else {
        this.setting.yearObjective = year;
      }
    },
    handleYearEvaluationSelection(year) {
      if (year.year === 'Autres') {
        this.$bvModal.show('evaluation-year-modal');
      } else {
        this.setting.yearEvaluation = year;
      }
    },
    async handleObjectiveYearSubmit() {
      if (this.customObjectiveYear && !isNaN(this.customObjectiveYear)) {
        const year = { year: parseInt(this.customObjectiveYear) };

        try {
          this.setting.yearObjective = await addYears(year);

          await this.getAllYears();
          this.showToast('Année ajoutée avec succès', 'success', 'CheckIcon');
        } catch (error) {
          console.error("Erreur lors de l'ajout de l'année :", error);
          this.showToast("Erreur lors de l'ajout de l'année", 'danger', 'XIcon');
        }
      }
      else {
        this.showToast("Année invalide", 'danger', 'XIcon');
      }
      this.$bvModal.hide('objective-year-modal');
    },
    async handleEvaluationYearSubmit() {
      if (this.customEvaluationYear && !isNaN(this.customEvaluationYear)) {
        const year = { year: parseInt(this.customEvaluationYear) };

        try {
          this.setting.yearEvaluation = await addYears(year);

          await this.getAllYears();
          this.showToast('Année ajoutée avec succès', 'success', 'CheckIcon');
        } catch (error) {
          console.error("Erreur lors de l'ajout de l'année :", error);
          this.showToast("Erreur lors de l'ajout de l'année", 'danger', 'XIcon');
        }
      } else {
        this.showToast("Année invalide", 'danger', 'XIcon');
      }
      this.$bvModal.hide('evaluation-year-modal');
    },

    async getAllConfigs() {
      try {
        this.evaluationIntervalConfigs = await getAllConfigs();
      } catch (error) {
        this.showToast('Erreur lors de la récupération des configurations', 'danger', 'XIcon');
      }
    },
    async handleConfigSubmit(bvModalEvt) {
      bvModalEvt.preventDefault(); // Empêche la fermeture automatique
      const config = {
        id: this.newConfig.id,
        minCollaborators: this.newConfig.minCollaborators,
        maxCollaborators: this.newConfig.maxCollaborators,
        intervalDays: this.newConfig.intervalDays,
      };

      // Validation simple
      if (!config.minCollaborators || !config.maxCollaborators || !config.intervalDays) {
        this.showToast('Tous les champs sont requis', 'danger', 'XIcon');
        return;
      }
      if (config.minCollaborators > config.maxCollaborators) {
        this.showToast('Le minimum doit être inférieur ou égal au maximum', 'danger', 'XIcon');
        return;
      }

      try {
        if (this.editingConfig) {
          await updateConfig(config.id, config);
          this.showToast('Configuration mise à jour avec succès', 'success', 'CheckIcon');
        } else {
          await addConfig(config);
          this.showToast('Configuration ajoutée avec succès', 'success', 'CheckIcon');
        }
        await this.getAllConfigs(); // Rafraîchir la liste
        this.$bvModal.hide('add-config-modal');
      } catch (error) {
        this.showToast('Erreur lors de l’enregistrement de la configuration', 'danger', 'XIcon');
      }
    },

    editConfig(config) {
      this.newConfig = { ...config }; // Copier les données pour modification
      this.editingConfig = true;
      this.$bvModal.show('add-config-modal');
    },

    async deleteConfig(id) {
      try {
        await deleteConfig(id);
        this.showToast('Configuration supprimée avec succès', 'success', 'CheckIcon');
        await this.getAllConfigs(); // Rafraîchir la liste
      } catch (error) {
        this.showToast('Erreur lors de la suppression de la configuration', 'danger', 'XIcon');
      }
    },

    resetConfigModal() {
      this.newConfig = {
        id: null,
        minCollaborators: null,
        maxCollaborators: null,
        intervalDays: null,
      };
      this.editingConfig = false;
    },

    resetObjectiveYearModal() {
      this.customObjectiveYear = null;
    },
    resetEvaluationYearModal() {
      this.customEvaluationYear = null;
    },
  },
  mounted() {
    this.getAllYears();

    this.getAllConfigs();

    getSetting()
        .then((response) => {
          if (response && typeof response === 'object') {
            this.setting = response;
          } else {
            this.setting = { id: null, email: '', objectiveStartDate: null, objectiveRelanceDelay: 1, evaluationStartDate: null, evaluationRelanceDelay: 1 };
          }
        })
        .catch((error) => {
          console.error('Error fetching settings:', error);
          this.setting = { id: null, email: '', objectiveStartDate: null, objectiveRelanceDelay: 1, evaluationStartDate: null, evaluationRelanceDelay: 1 };
        });
    getAllDisabledUsers(false)
        .then(response => {
          this.users = response.map(user => ({
            ...user,
            fullName: `${user.lastName} ${user.firstName}`,
          }));
        })
        .catch(error => {
          console.error('Error fetching users:', error);
        });
    getAllDecisionMakingUser()
        .then(response => {
          this.decisionMakingUser = response || [
            { id: null, site: 'SIRAT', user: {} },
            { id: null, site: 'PEAGE', user: {} },
          ];
          this.user_s = this.users.find(user => user.id === this.decisionMakingUser[0]?.user?.id) || {};
          this.user_p = this.users.find(user => user.id === this.decisionMakingUser[1]?.user?.id) || {};
        })
        .catch(error => {
          console.error('Error fetching decision-making users:', error);
        });
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
